import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const InsideCarLayout: FormLayoutPage = {
  key: 'inside-car',
  title: 'Inside the Car',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.typeOfUse,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasCounterWeights,
    layoutFields.hasMGSet,
    layoutFields.yearGearboxOilChanged,
    layoutFields.hasEmergencyPower,
    layoutFields.hoistwayDoorType,
    layoutFields.carDoorType,
    layoutFields.numLandings, // AKA Number of Hoistway Entrances
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.hasHoistwayAccess,
    layoutFields.hasFirefighterService,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
  ],
}

const OutsideCarLayout: FormLayoutPage = {
  key: 'outside-car',
  title: 'Outside the Car',
  contents: [
    layoutFields.interlocksInstallYear,
    layoutFields.typeOfDoorOperator,
    layoutFields.doorRestrictorType,
    layoutFields.hasSeismicDevices,
    layoutFields.guideType,
    layoutFields.bufferType,
    layoutFields.hasBufferSwitches,
    layoutFields.travelingCable,
    layoutFields.pitPermitRequired,
    layoutFields.hasUnderPlatformObstructionDevice,
    layoutFields.typeOfMast,
    layoutFields.numberOfMastTies,
    layoutFields.numberOfMastSections,
    layoutFields.numberOfMotors,
    layoutFields.doorOperatorManufacturerAndModel,
  ],
}

export const RackAndPinionFormLayout: FormLayout =
  buildLayoutWithCommonSections([
    BasicInfoLayout,
    InsideCarLayout,
    OutsideCarLayout,
    NotesLayout,
  ])
